export const MILLIS = 1;
export const SECONDS = 1000 * MILLIS;
export const MINUTES = 60 * SECONDS;
